import React, {Dispatch, FC, SetStateAction, useEffect, useState, useRef, useCallback} from 'react';
import {Col, Form, Input, message, Radio, Row, Switch} from "antd";
import {useAppDispatch, useAppSelector} from "../../../../../store/store";
import {clearCreateEventCalendar, createEventCalendar, updateEventCalendar, deleteEventCalendar, clearUpdateEventCalendar, hideEventCalendar, clearHideEventCalendar} from "../../../../../store/reducers/eventCalendarReducer/eventCalendarReducer";
import {getPlaneList} from "../../../../../store/reducers/fleetReducer/fleetReducer";
import {InitialPage} from "../../../../../utils/constans/pagination/pagination";
import {DebounceSelect} from "../../../../../components/UI/AntCustom/DebounceSelect";
import {CustomInputNumber} from "../../../../../components/UI/AntCustom/CustomInputNumber";
import {fetchAirports} from "../../../../../utils/helpers/selectDataFetchers/fetchAirports";
import {fetchCurrencies, getCurrencyById, getInitialCurrencyForSelect, getCurrenciesFromStoreByIds} from "../../../../../utils/helpers/selectDataFetchers/fetchCurrencies";
import {fetchPlaneCategories} from "../../../../../utils/helpers/selectDataFetchers/fetchPlaneCategories";
import {DebounceSelectOptionProps} from "../../../../../components/UI/AntCustom/DebounceSelect";
import {IPlaneCategory} from "../../../../../store/reducers/fleetReducer/fleetReducerTypes";
import {CustomModal} from "../../../../../components/UI/AntCustom/CustomModal";
import {CustomFieldInput} from "../../../../../components/UI/AntCustom/CustomFieldInput";
import {CustomButton} from "../../../../../components/UI/AntCustom/CustomButton";
import {defineMessages, useIntl} from "react-intl";
import {CommonFormMessages} from "../../../../../intl/commonMessages/CommonFormMessages";
import {CommonButtonMessages} from "../../../../../intl/commonMessages/CommonButtonMessages";
import {onFinishTrimmed} from "../../../../../utils/helpers/formHelpers/onFinishTrimmed";
import {getErrorMessageByCode} from "../../../../../utils/constans/errorCodes/errorCodes";
import dayjs, {Dayjs} from "dayjs";
import {DateAndTimeRangePicker} from "../../../../../components/UI/AntCustom/DateAndTimeRangePicker";
import {ColorPicker} from "../../../../../components/UI/AntCustom/ColorPicker";
import styled from "styled-components";
import {PlusOutlined, MinusCircleOutlined} from "@ant-design/icons";
import {IEventCalendar} from "../../../../../store/reducers/eventCalendarReducer/eventCalendarReducerTypes";
import {AirportApiGetAirportRequest, AirportApiGetExtendedAirportRequest} from "../../../../../proto/generated/api_entities_pb";
import {API} from "../../../../../API/API";
import {Role} from "../../../../../config/acl/roles/Role";
import {store} from "../../../../../store/store";

const BlockWrapper = styled.div`
  background-color: #f5f5f5;
  padding: 16px;
  border-radius: 6px;
  margin-bottom: 16px;
  
  .ant-input,
  .ant-input-number,
  .ant-select-selector,
  .ant-input-number-input-wrap {
    background-color: #FFFFFF !important;
  }
  
  .ant-select {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
  }
  
  .ant-select-selector {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding: 12px 12px !important;
  }
  
  .ant-select-selection-item {
    max-width: 100% !important;
    padding-left: 0 !important;
  }
  
  .ant-select-selection-search {
    margin-left: 0 !important;
  }
  
  /* Обеспечиваем видимость и работу поля поиска в мультиселекте */
  .ant-select-multiple .ant-select-selection-search {
    display: flex !important;
    flex: 1 1 auto !important;
    min-width: 4px !important;
    margin-inline-start: 0 !important;
    position: relative !important;
    z-index: 1 !important;
  }
  
  .ant-select-multiple .ant-select-selection-search-input {
    min-width: 4px !important;
    width: auto !important;
    flex: 1 1 auto !important;
    border: none !important;
    outline: none !important;
    background: transparent !important;
  }
  
  /* Убеждаемся, что поле поиска видно даже когда селект не в фокусе (для мультиселекта) */
  .ant-select-multiple:not(.ant-select-focused) .ant-select-selection-search {
    display: flex !important;
  }
`;

const BlockTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 16px;
  color: #000;
`;

const RemoveBlockButton = styled(MinusCircleOutlined)`
  color: #ff4d4f;
  font-size: 18px;
  cursor: pointer;
  
  &:hover {
    color: #ff7875;
  }
`;

const AddBlockButton = styled(CustomButton)`
  margin-bottom: 16px;
  
  && {
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #D9DAD9;
    color: #000000;
  }
  
  &&:hover,
  &&:focus {
    background: #FFFFFF;
    border-color: #D9DAD9;
    color: #000000;
  }
`;

const ColorFieldWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: stretch;
  
  .ant-form-item {
    margin: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  
  .ant-form-item-control {
    flex: 1;
    display: flex;
    align-items: stretch;
  }
  
  .ant-form-item-control-input {
    flex: 1;
    display: flex;
    align-items: stretch;
    min-height: 32px;
  }
  
  .ant-form-item-control-input-content {
    display: flex;
    align-items: stretch;
    height: 100%;
    min-height: 32px;
  }
`;

const ColorColWrapper = styled.div`
  .ant-row {
    display: flex;
    align-items: stretch;
  }
  
  .ant-col:last-child {
    display: flex !important;
    align-items: stretch !important;
    height: 100% !important;
  }
`;

const CurrencySelectWrapper = styled.div`
  width: 100% !important;
  min-width: 100% !important;
  max-width: 100% !important;
  flex: 1 1 auto !important;
  box-sizing: border-box !important;
  
  > * {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
  }
  
  .ant-select {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    flex: 1 1 auto !important;
    box-sizing: border-box !important;
  }
  
  .ant-select-selector {
    padding-left: 11px !important;
    padding-right: 11px !important;
    
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
  }
  
  .ant-select-selection-search {
    width: 100% !important;
    min-width: 0 !important;
    flex: 1 1 auto !important;
  }
  
  .ant-select-selection-item {
    flex: 1 1 auto !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    max-width: 100% !important;
    min-width: 0 !important;
    display: inline-block !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  
  .ant-select-selection-placeholder {
    flex: 1 1 auto !important;
    width: 100% !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  
  .ant-select-selection-overflow {
    width: 100% !important;
    flex: 1 1 auto !important;
  }
  
  .ant-select-selection-single {
    width: 100% !important;
    min-width: 100% !important;
  }
  
  .ant-select-selection {
    width: 100% !important;
    min-width: 100% !important;
  }
  
  .ant-select-focused .ant-select-selector {
    width: 100% !important;
    min-width: 100% !important;
    padding-left: 11px !important;
    padding-right: 11px !important;
  }
`;

const StyledEventCalendarModal = styled(CustomModal)<{ isDropdownOpen?: boolean }>`
  .ant-modal-content {
    max-height: 80vh;
    display: flex;
    flex-direction: column;
  }
  
  .ant-modal-body {
    overflow-y: ${props => props.isDropdownOpen ? 'hidden' : 'auto'};
    flex: 1;
  }
`;

const EventCalendarCreateModalMessages = defineMessages({
  title: {
    id: "eventCalendarCreateModal.title",
    defaultMessage: "Создание события",
  },
  titleEdit: {
    id: "eventCalendarCreateModal.titleEdit",
    defaultMessage: "Редактировать событие",
  },
  delete: {
    id: "eventCalendarCreateModal.delete",
    defaultMessage: "Delete",
  },
  hide: {
    id: "eventCalendarCreateModal.hide",
    defaultMessage: "Скрыть",
  },
  hideSuccess: {
    id: "eventCalendarCreateModal.hideSuccess",
    defaultMessage: "Событие скрыто",
  },
  duplicate: {
    id: "eventCalendarCreateModal.duplicate",
    defaultMessage: "Дублировать",
  },
  eventName: {
    id: "eventCalendarCreateModal.eventName",
    defaultMessage: "Название",
  },
  color: {
    id: "eventCalendarCreateModal.color",
    defaultMessage: "Цвет",
  },
  eventDates: {
    id: "eventCalendarCreateModal.eventDates",
    defaultMessage: "Даты события",
  },
  airport: {
    id: "eventCalendarCreateModal.airport",
    defaultMessage: "Аэропорт",
  },
  priceLight: {
    id: "eventCalendarCreateModal.priceLight",
    defaultMessage: "Цена на класс Light",
  },
  priceMidsize: {
    id: "eventCalendarCreateModal.priceMidsize",
    defaultMessage: "Цена на класс Midsize",
  },
  highSeason: {
    id: "eventCalendarCreateModal.highSeason",
    defaultMessage: "Высокий сезон",
  },
  lowSeason: {
    id: "eventCalendarCreateModal.lowSeason",
    defaultMessage: "Низкий сезон",
  },
  addBlock: {
    id: "eventCalendarCreateModal.addBlock",
    defaultMessage: "Добавить еще блок",
  },
  block: {
    id: "eventCalendarCreateModal.block",
    defaultMessage: "БЛОК",
  },
  seasonType: {
    id: "eventCalendarCreateModal.seasonType",
    defaultMessage: "Тип сезона",
  },
  dateFrom: {
    id: "eventCalendarCreateModal.dateFrom",
    defaultMessage: "Дата начала",
  },
  dateTo: {
    id: "eventCalendarCreateModal.dateTo",
    defaultMessage: "Дата окончания",
  },
});

interface IEventBlockPrice {
  planeCategoryId?: number; // Используем категорию (Light, Midsize, Heavy и т.д.) - для фронта
  price?: number;
  currencyId?: number | DebounceSelectOptionProps; // Для формы может быть объект, для сохранения - число
  // planeTypeId используется для бекенда (но на самом деле это категория)
  planeTypeId?: number;
}

interface IEventBlock {
  airportIds: number[];
  prices?: IEventBlockPrice[];
  // Старые поля для обратной совместимости
  priceLight?: number;
  currencyLightId?: number;
  priceMidsize?: number;
  currencyMidsizeId?: number;
}

interface IEventCalendarCreateFormData {
  eventName: string;
  color: string;
  dateRange: [Dayjs, Dayjs];
  blocks?: IEventBlock[];
  prices?: IEventBlockPrice[]; // Для сезонов
  priceLight?: number; // Старые поля для обратной совместимости
  currencyLightId?: number;
  priceMidsize?: number;
  currencyMidsizeId?: number;
  seasonType?: 'high' | 'low';
}

interface IEventCalendarCreateModal {
  isModalVisible: boolean;
  setIsModalVisible: Dispatch<SetStateAction<boolean>>;
  isSeason?: boolean;
  duplicateFrom?: IEventCalendar;
  editEvent?: IEventCalendar; // Событие для редактирования
  onDelete?: () => void; // Callback для удаления
  onDuplicate?: () => void; // Callback для дублирования
  onSuccess?: () => void;
}

export const EventCalendarCreateModal: FC<IEventCalendarCreateModal> = ({isModalVisible, setIsModalVisible, isSeason = false, duplicateFrom, editEvent, onDelete, onDuplicate, onSuccess}) => {
  const [form] = Form.useForm();
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const {
    isLoading: isCreateLoading,
    isSuccess: isCreateSuccess,
    errorMessage: createErrorMessage,
  } = useAppSelector(state => state.eventCalendar.createEventCalendar);
  
  const {
    isLoading: isUpdateLoading,
    isSuccess: isUpdateSuccess,
    errorMessage: updateErrorMessage,
  } = useAppSelector(state => state.eventCalendar.updateEventCalendar);
  
  const {
    isLoading: isHideLoading,
    isSuccess: isHideSuccess,
    errorMessage: hideErrorMessage,
  } = useAppSelector(state => state.eventCalendar.hideEventCalendar);
  
  const lastCreatedEventCalendarTimestamp = useAppSelector(state => state.eventCalendar.lastCreatedEventCalendarTimestamp);

  const isLoading = isCreateLoading || isUpdateLoading || isHideLoading;
  const isSuccess = isCreateSuccess || isUpdateSuccess;
  const errorMessage = createErrorMessage || updateErrorMessage;
  
  // Определяем роль пользователя для установки правильного source
  const userRole = useAppSelector(state => state.auth.role);
  const isSystemAdmin = userRole === Role.admin;
  
  // Получаем валюту из профиля пользователя или компании (как в UserSettingsDrawer)
  const user = useAppSelector(state => state.user.oneItemObject.item);
  const company = useAppSelector(state => state.company.oneItemObject.item);
  const userCurrency = user.currency ?? company.currency;
  
  // Проверяем, загружены ли валюты в стор
  const currenciesFromStore = useAppSelector(state => state.currency.currencies);
  const currenciesLoading = useAppSelector(state => state.currency.isLoading);
  
  // Отслеживаем предыдущее значение isSuccess для определения перехода false → true
  const prevIsSuccessRef = useRef<boolean>(false);
  const prevIsHideSuccessRef = useRef<boolean>(false);
  // Флаг для отслеживания, что модалка только что открылась (чтобы игнорировать старые isSuccess)
  const justOpenedRef = useRef<boolean>(false);
  // Флаг для отслеживания, что запрос был отправлен после открытия модалки
  const requestWasSentRef = useRef<boolean>(false);
  // Ref для отслеживания timestamp запроса создания события
  const createRequestTimestampRef = useRef<number | null>(null);
  
  // Состояние для хранения списка категорий самолетов
  const [planeCategories, setPlaneCategories] = useState<DebounceSelectOptionProps[]>([]);
  
  // Состояние для отслеживания открытых дропдаунов
  const [openDropdownsCount, setOpenDropdownsCount] = useState(0);
  
  // Получаем самолеты оператора из флота
  const operatorPlanes = useAppSelector(state => state.fleet.itemsObject.items);
  
  // Загружаем самолеты оператора при открытии модалки, если их нет
  useEffect(() => {
    if (isModalVisible && !isSystemAdmin) {
      const currentState = store.getState();
      const currentPlanes = currentState.fleet.itemsObject.items;
      const isLoading = currentState.fleet.itemsObject.isLoading;
      
      if (currentPlanes.length === 0 && !isLoading) {
        dispatch(getPlaneList({
          query: '',
          page: InitialPage
        }));
      }
    }
  }, [isModalVisible, isSystemAdmin, dispatch, operatorPlanes.length]);

  // Функция для извлечения ID категорий из самолетов
  const extractCategoryIdsFromPlanes = useCallback((planes: any[]) => {
    const categoryIdsSet = new Set<number>();
    const categoryMap = new Map<number, string>(); // ID -> название
    
    planes.forEach((plane: any) => {
      // Берем planecategoryid из самолета
      const categoryId = plane.planeType?.planeCategory?.id;
      const categoryName = plane.planeType?.planeCategory?.name;
      
      if (categoryId) {
        categoryIdsSet.add(categoryId);
        if (categoryName && !categoryMap.has(categoryId)) {
          categoryMap.set(categoryId, categoryName);
        }
      }
    });
    
    // Преобразуем в формат для селекта
    const categories: DebounceSelectOptionProps[] = Array.from(categoryIdsSet).map(categoryId => ({
      key: categoryId,
      value: categoryId,
      label: categoryMap.get(categoryId) || `Category ${categoryId}`, // Используем название из самолета или дефолтное
    }));
    
    return categories;
  }, []);

  // Загружаем категории самолетов при открытии модалки или изменении списка самолетов
  useEffect(() => {
    if (isModalVisible) {
      const loadPlaneCategories = async () => {
        try {
          if (isSystemAdmin) {
            // Для админа - все категории из системы
            const categories = await fetchPlaneCategories('');
            setPlaneCategories(categories);
          } else {
            // Для оператора - категории из его самолетов
            // Функция для попытки извлечения категорий
            const tryExtractCategories = () => {
              const currentState = store.getState();
              const currentPlanes = currentState.fleet.itemsObject.items;
              const isLoading = currentState.fleet.itemsObject.isLoading;
              
              // Используем самолеты из селектора, если они есть, иначе из store
              const planesToUse = operatorPlanes.length > 0 ? operatorPlanes : currentPlanes;
              
              if (planesToUse.length === 0) {
                if (isLoading) {
                  return false; // Продолжаем ждать
                } else {
                  setPlaneCategories([]);
                  return true; // Завершаем попытки
                }
              }
              
              // Извлекаем planecategoryid из самолетов
              const categories = extractCategoryIdsFromPlanes(planesToUse);
              setPlaneCategories(categories);
              return true; // Успешно завершено
            };
            
            // Пытаемся извлечь категории
            if (!tryExtractCategories()) {
              // Если самолеты еще загружаются, проверяем периодически
              const checkInterval = setInterval(() => {
                if (tryExtractCategories()) {
                  clearInterval(checkInterval);
                }
              }, 500);
              
              // Останавливаем проверку через 10 секунд
              setTimeout(() => {
                clearInterval(checkInterval);
              }, 10000);
            }
          }
        } catch (error) {
          setPlaneCategories([]);
        }
      };
      
      loadPlaneCategories();
    }
  }, [isModalVisible, isSystemAdmin, operatorPlanes, dispatch, extractCategoryIdsFromPlanes]);
  
  useEffect(() => {
    if (isModalVisible) {
      // Очищаем состояние при открытии модалки
      // Сбрасываем ref, чтобы отслеживать только новые успешные операции после открытия модалки
      prevIsSuccessRef.current = false;
      prevIsHideSuccessRef.current = false;
      // Устанавливаем флаг, что модалка только что открылась
      justOpenedRef.current = true;
      // Сбрасываем счетчик открытых дропдаунов
      setOpenDropdownsCount(0);
      
      dispatch(clearCreateEventCalendar());
      dispatch(clearUpdateEventCalendar());
      dispatch(clearHideEventCalendar());
      
      // Сбрасываем флаг через задержку, чтобы дать время состоянию очиститься после dispatch
      // Это предотвращает закрытие модалки из-за старого значения isSuccess
      setTimeout(() => {
        justOpenedRef.current = false;
      }, 200);
      
      // Сбрасываем флаг отправки запроса
      requestWasSentRef.current = false;
      
      if (duplicateFrom && !editEvent) {
        // Заполнение формы при дублировании
        const fillDuplicateFormData = () => {
          if (planeCategories.length === 0) {
            setTimeout(fillDuplicateFormData, 100);
            return;
          }
          
          const state = store.getState();
          const currencies = state.currency?.currencies || [];
          const duplicatedEventName = duplicateFrom.eventName.endsWith(':copy') 
            ? duplicateFrom.eventName 
            : `${duplicateFrom.eventName}:copy`;
          
          if (isSeason) {
            const allPrices: IEventBlockPrice[] = planeCategories.map(planeCategory => {
              const categoryId = Number(planeCategory.value);
              const defaultCurrency = userCurrency && userCurrency.id ? getInitialCurrencyForSelect(userCurrency) : undefined;
              
              let price: number | undefined = undefined;
              let currencyId: any = defaultCurrency;
              
              if (duplicateFrom.blocks && duplicateFrom.blocks.length > 0) {
                const firstBlock = duplicateFrom.blocks[0];
                
                if (categoryId === 1 && firstBlock.priceLight !== undefined && firstBlock.priceLight !== null) {
                  price = firstBlock.priceLight;
                  if (firstBlock.currencyLightId) {
                    const currency = currencies.find(c => Number(c.value) === Number(firstBlock.currencyLightId));
                    currencyId = currency || defaultCurrency;
                  }
                } else if (categoryId === 2 && firstBlock.priceMidsize !== undefined && firstBlock.priceMidsize !== null) {
                  price = firstBlock.priceMidsize;
                  if (firstBlock.currencyMidsizeId) {
                    const currency = currencies.find(c => Number(c.value) === Number(firstBlock.currencyMidsizeId));
                    currencyId = currency || defaultCurrency;
                  }
                }
              }
              
              return {
                planeCategoryId: categoryId,
                planeTypeId: categoryId,
                price: price,
                currencyId: currencyId,
              };
            });
            
            form.setFieldsValue({
              eventName: duplicatedEventName,
              color: duplicateFrom.color || '#1890FF',
              seasonType: duplicateFrom.seasonType || 'high',
              dateRange: [dayjs(duplicateFrom.dateFrom), dayjs(duplicateFrom.dateTo)],
              prices: allPrices,
            });
          } else {
            const blocks = duplicateFrom.blocks && duplicateFrom.blocks.length > 0
              ? duplicateFrom.blocks.map((block) => {
                  const allPrices: IEventBlockPrice[] = planeCategories.map(planeCategory => {
                    const categoryId = Number(planeCategory.value);
                    const defaultCurrency = userCurrency && userCurrency.id ? getInitialCurrencyForSelect(userCurrency) : undefined;
                    
                    let price: number | undefined = undefined;
                    let currencyId: any = defaultCurrency;
                    
                    if (block.prices && block.prices.length > 0) {
                      const priceItem = block.prices.find(p => p.planeTypeId === categoryId);
                      if (priceItem) {
                        price = priceItem.price;
                        if (priceItem.currencyId) {
                          const currency = currencies.find(c => Number(c.value) === Number(priceItem.currencyId));
                          currencyId = currency || defaultCurrency;
                        }
                      }
                    } else {
                      if (categoryId === 1 && block.priceLight !== undefined && block.priceLight !== null) {
                        price = block.priceLight;
                        if (block.currencyLightId) {
                          const currency = currencies.find(c => Number(c.value) === Number(block.currencyLightId));
                          currencyId = currency || defaultCurrency;
                        }
                      } else if (categoryId === 2 && block.priceMidsize !== undefined && block.priceMidsize !== null) {
                        price = block.priceMidsize;
                        if (block.currencyMidsizeId) {
                          const currency = currencies.find(c => Number(c.value) === Number(block.currencyMidsizeId));
                          currencyId = currency || defaultCurrency;
                        }
                      }
                    }
                    
                    return {
                      planeCategoryId: categoryId,
                      planeTypeId: categoryId,
                      price: price,
                      currencyId: currencyId,
                    };
                  });
                  
                  return {
                    airportIds: block.airportIds || [],
                    prices: allPrices,
                  };
                })
              : [{
                  airportIds: [],
                  prices: planeCategories.map(planeCategory => {
                    const defaultCurrency = userCurrency && userCurrency.id ? getInitialCurrencyForSelect(userCurrency) : undefined;
                    return {
                      planeCategoryId: Number(planeCategory.value),
                      planeTypeId: Number(planeCategory.value),
                      price: undefined,
                      currencyId: defaultCurrency,
                    };
                  }),
                }];
            
            form.setFieldsValue({
              eventName: duplicatedEventName,
              color: duplicateFrom.color || '#1890FF',
              dateRange: [dayjs(duplicateFrom.dateFrom), dayjs(duplicateFrom.dateTo)],
              blocks: blocks,
            });
          }
        };
        
        setTimeout(fillDuplicateFormData, 200);
      } else if (editEvent) {
        // Простое заполнение формы - берем данные из editEvent и заполняем
        const fillFormData = () => {
          if (planeCategories.length === 0) {
            // Если категории еще не загружены, ждем
            setTimeout(fillFormData, 100);
            return;
          }
          
          const state = store.getState();
          const currencies = state.currency?.currencies || [];
          
          if (isSeason) {
            // Для сезонов
            const allPrices: IEventBlockPrice[] = planeCategories.map(planeCategory => {
              const categoryId = Number(planeCategory.value);
              const defaultCurrency = userCurrency && userCurrency.id ? getInitialCurrencyForSelect(userCurrency) : undefined;
              
              let price: number | undefined = undefined;
              let currencyId: any = defaultCurrency;
              
              if (editEvent.blocks && editEvent.blocks.length > 0) {
                const firstBlock = editEvent.blocks[0];
                
                // Старые поля priceLight/currencyLightId
                if (categoryId === 1 && firstBlock.priceLight !== undefined && firstBlock.priceLight !== null) {
                  price = firstBlock.priceLight;
                  if (firstBlock.currencyLightId) {
                    const currency = currencies.find(c => Number(c.value) === Number(firstBlock.currencyLightId));
                    currencyId = currency || defaultCurrency;
                  }
                } else if (categoryId === 2 && firstBlock.priceMidsize !== undefined && firstBlock.priceMidsize !== null) {
                  price = firstBlock.priceMidsize;
                  if (firstBlock.currencyMidsizeId) {
                    const currency = currencies.find(c => Number(c.value) === Number(firstBlock.currencyMidsizeId));
                    currencyId = currency || defaultCurrency;
                  }
                }
              }
              
              return {
                planeCategoryId: categoryId,
                planeTypeId: categoryId,
                price: price,
                currencyId: currencyId,
              };
            });
            
            form.setFieldsValue({
              eventName: editEvent.eventName,
              color: editEvent.color || '#1890FF',
              seasonType: editEvent.seasonType || 'high',
              dateRange: [dayjs(editEvent.dateFrom), dayjs(editEvent.dateTo)],
              prices: allPrices,
            });
          } else {
            // Для событий - блоки
            const blocks = editEvent.blocks && editEvent.blocks.length > 0
              ? editEvent.blocks.map((block) => {
                  const allPrices: IEventBlockPrice[] = planeCategories.map(planeCategory => {
                    const categoryId = Number(planeCategory.value);
                    const defaultCurrency = userCurrency && userCurrency.id ? getInitialCurrencyForSelect(userCurrency) : undefined;
                    
                    let price: number | undefined = undefined;
                    let currencyId: any = defaultCurrency;
                    
                    // Сначала проверяем массив prices (новая структура)
                    if (block.prices && block.prices.length > 0) {
                      const priceItem = block.prices.find(p => p.planeTypeId === categoryId);
                      if (priceItem) {
                        price = priceItem.price;
                        if (priceItem.currencyId) {
                          const currency = currencies.find(c => Number(c.value) === Number(priceItem.currencyId));
                          currencyId = currency || defaultCurrency;
                        }
                      }
                    } else {
                      // Обратная совместимость: старые поля priceLight/currencyLightId
                      if (categoryId === 1 && block.priceLight !== undefined && block.priceLight !== null) {
                        price = block.priceLight;
                        if (block.currencyLightId) {
                          const currency = currencies.find(c => Number(c.value) === Number(block.currencyLightId));
                          currencyId = currency || defaultCurrency;
                        }
                      } else if (categoryId === 2 && block.priceMidsize !== undefined && block.priceMidsize !== null) {
                        price = block.priceMidsize;
                        if (block.currencyMidsizeId) {
                          const currency = currencies.find(c => Number(c.value) === Number(block.currencyMidsizeId));
                          currencyId = currency || defaultCurrency;
                        }
                      }
                    }
                    
                    return {
                      planeCategoryId: categoryId,
                      planeTypeId: categoryId,
                      price: price,
                      currencyId: currencyId,
                    };
                  });
                  
                  return {
                    airportIds: block.airportIds || [],
                    prices: allPrices,
                  };
                })
              : [{
                  airportIds: [],
                  prices: planeCategories.map(planeCategory => {
                    const defaultCurrency = userCurrency && userCurrency.id ? getInitialCurrencyForSelect(userCurrency) : undefined;
                    return {
                      planeCategoryId: Number(planeCategory.value),
                      planeTypeId: Number(planeCategory.value),
                      price: undefined,
                      currencyId: defaultCurrency,
                    };
                  }),
                }];
            
            form.setFieldsValue({
              eventName: editEvent.eventName,
              color: editEvent.color || '#1890FF',
              dateRange: [dayjs(editEvent.dateFrom), dayjs(editEvent.dateTo)],
              blocks: blocks,
            });
          }
        };
        
        // Заполняем форму с небольшой задержкой
        setTimeout(fillFormData, 200);
      } else {
        // Сбрасываем форму при создании нового события
        form.resetFields();
        // Сбрасываем timestamp запроса
        createRequestTimestampRef.current = null;
        // Получаем валюту из профиля для установки по умолчанию
        const defaultCurrency = userCurrency && userCurrency.id ? getInitialCurrencyForSelect(userCurrency) : undefined;
        // Устанавливаем начальные значения для создания
        form.setFieldsValue({
          color: '#1890FF',
          ...(isSeason ? {
            seasonType: 'high',
            currencyLightId: defaultCurrency as any,
            currencyMidsizeId: defaultCurrency as any,
          } : {
            blocks: [{
              airportIds: [],
              priceLight: undefined,
              currencyLightId: defaultCurrency as any,
              priceMidsize: undefined,
              currencyMidsizeId: defaultCurrency as any,
            }],
          }),
        });
      }
    } else {
      // Сброс состояния при закрытии модалки
      dispatch(clearCreateEventCalendar());
      dispatch(clearUpdateEventCalendar());
      dispatch(clearHideEventCalendar());
      // Сбрасываем форму при закрытии
      form.resetFields();
      // Сбрасываем предыдущее значение isSuccess при закрытии модалки
      prevIsSuccessRef.current = false;
      prevIsHideSuccessRef.current = false;
      justOpenedRef.current = false;
      createRequestTimestampRef.current = null;
      // Сбрасываем счетчик открытых дропдаунов
      setOpenDropdownsCount(0);
    }
  }, [isModalVisible, editEvent, duplicateFrom, isSeason, form, dispatch, isHideLoading, isHideSuccess, hideErrorMessage, planeCategories, userCurrency])

  // Отслеживаем отправку запроса (isLoading становится true)
  useEffect(() => {
    if (isModalVisible && isLoading && !requestWasSentRef.current) {
      requestWasSentRef.current = true;
      console.log('[EventCalendarCreateModal] Request was sent, requestWasSentRef.current = true');
    }
  }, [isModalVisible, isLoading]);

  useEffect(() => {
    // При успешном создании/обновлении закрываем модалку и вызываем onSuccess
    // Упрощенная логика: если запрос был отправлен и успешно завершен, закрываем модалку
    if (isModalVisible && !isLoading && isSuccess) {
      console.log('[EventCalendarCreateModal] Success detected, checking conditions...');
      
      // Упрощенная проверка: если запрос был отправлен, закрываем модалку
      // Или если модалка была открыта достаточно долго (justOpenedRef сброшен)
      const shouldClose = requestWasSentRef.current || !justOpenedRef.current;
      
      console.log('[EventCalendarCreateModal] Should close?', shouldClose, {
        requestWasSent: requestWasSentRef.current,
        justOpened: justOpenedRef.current,
      });
      
      if (shouldClose) {
        console.log('[EventCalendarCreateModal] ✓ Closing modal after successful create/update');
        
        // Обновляем предыдущее значение ПЕРЕД закрытием, чтобы избежать повторных срабатываний
        prevIsSuccessRef.current = isSuccess;
        
        // Сначала очищаем состояние
        dispatch(clearCreateEventCalendar());
        dispatch(clearUpdateEventCalendar());
        dispatch(clearHideEventCalendar());
        form.resetFields();
        
        // Закрываем модалку
        setIsModalVisible(false);
        
        // Вызываем onSuccess для обновления списка (после небольшой задержки, чтобы модалка успела закрыться)
        if (onSuccess) {
          // Используем setTimeout, чтобы убедиться, что модалка закрылась перед обновлением
          setTimeout(() => {
            onSuccess();
          }, 100);
        }
        
        // Сбрасываем флаг отправки запроса
        requestWasSentRef.current = false;
      } else {
        console.log('[EventCalendarCreateModal] ✗ Not closing - conditions not met');
      }
    }
    
    // Обновляем предыдущее значение isSuccess для отслеживания изменений
    if (isSuccess !== prevIsSuccessRef.current && !isLoading) {
      console.log('[EventCalendarCreateModal] Updating prevIsSuccessRef from', prevIsSuccessRef.current, 'to', isSuccess);
      prevIsSuccessRef.current = isSuccess;
    }
    
    if (isModalVisible && !isLoading && errorMessage) {
      const userFriendlyMessage = getErrorMessageByCode(errorMessage);
      message.error(userFriendlyMessage);
    }
  }, [isSuccess, isCreateSuccess, isUpdateSuccess, errorMessage, isLoading, isCreateLoading, isUpdateLoading, isModalVisible, setIsModalVisible, form, dispatch, onSuccess])

  // Отслеживаем успешное скрытие события
  useEffect(() => {
    // Простое решение: закрываем модалку сразу после успешного скрытия
    if (isModalVisible && !isHideLoading && isHideSuccess && !prevIsHideSuccessRef.current) {
      dispatch(clearHideEventCalendar());
      setIsModalVisible(false);
      message.success(intl.formatMessage(EventCalendarCreateModalMessages.hideSuccess));
      if (onSuccess) {
        setTimeout(() => {
          onSuccess();
        }, 100);
      }
    }
    
    prevIsHideSuccessRef.current = isHideSuccess;
    
    if (isModalVisible && !isHideLoading && hideErrorMessage) {
      const userFriendlyMessage = getErrorMessageByCode(hideErrorMessage);
      message.error(userFriendlyMessage);
    }
  }, [isHideSuccess, hideErrorMessage, isHideLoading, isModalVisible, setIsModalVisible, dispatch, onSuccess, intl, editEvent])

  const onFinish = async (values: IEventCalendarCreateFormData) => {
    
    // Проверяем, есть ли ошибки валидации перед выполнением
    const fieldsError = form.getFieldsError();
    if (fieldsError.length > 0) {
      console.warn('=== WARNING: Form has validation errors but onFinish was called ===');
      fieldsError.forEach((fieldError: any) => {
        console.warn(`Field: ${JSON.stringify(fieldError.name)}, Errors: ${fieldError.errors.join(', ')}`);
      });
    }
    
    // Извлекаем currencyLightId и currencyMidsizeId из объектов для сезонов (если это сезон)
    // Это нужно сделать до всех проверок, чтобы использовать нормализованные значения
    let currencyLightId: number | undefined;
    let currencyMidsizeId: number | undefined;
    
    if (isSeason) {
      currencyLightId = typeof values.currencyLightId === 'object' && values.currencyLightId !== null
        ? (values.currencyLightId as any).value
        : values.currencyLightId;
      
      currencyMidsizeId = typeof values.currencyMidsizeId === 'object' && values.currencyMidsizeId !== null
        ? (values.currencyMidsizeId as any).value
        : values.currencyMidsizeId;
    }
    
    // Проверяем обязательные поля
    const missingFields: string[] = [];
    
    if (!values.eventName) {
      missingFields.push('eventName');
    }
    if (!values.color) {
      missingFields.push('color');
    }
    if (!values.dateRange || !values.dateRange[0] || !values.dateRange[1]) {
      missingFields.push('dateRange');
    }
    
    if (isSeason) {
      if (!values.seasonType) {
        missingFields.push('seasonType');
      }
      
      // Проверяем новую структуру prices - требуется хотя бы одна валюта (цена не обязательна, будет 0)
      const hasAnyCurrency = values.prices && Array.isArray(values.prices) && values.prices.some((priceItem: IEventBlockPrice) => {
        const currencyId = priceItem?.currencyId;
        if (typeof currencyId === 'number') {
          return currencyId > 0;
        } else if (typeof currencyId === 'object' && currencyId !== null && 'value' in currencyId) {
          const currencyValue = typeof currencyId.value === 'number' ? currencyId.value : Number(currencyId.value);
          return currencyValue > 0;
        }
        return false;
      });
      
      // Проверяем старые поля для обратной совместимости
      const hasOldCurrency = (values.priceLight && currencyLightId) || (values.priceMidsize && currencyMidsizeId);
      
      if (!hasAnyCurrency && !hasOldCurrency) {
        missingFields.push('at least one currency required');
      }
      
      if (values.priceLight && !currencyLightId) {
        missingFields.push('currencyLightId (when priceLight is set)');
      }
      if (values.priceMidsize && !currencyMidsizeId) {
        missingFields.push('currencyMidsizeId (when priceMidsize is set)');
      }
    } else {
      if (!values.blocks || values.blocks.length === 0) {
        missingFields.push('blocks (at least one block required)');
      } else {
        values.blocks.forEach((block, index) => {
          // Проверяем, есть ли хотя бы одна заполненная пара (цена > 0 И валюта > 0) в блоке
          const hasAnyValidPrice = block.prices && Array.isArray(block.prices) && block.prices.some((priceItem: IEventBlockPrice) => {
            const price = priceItem?.price;
            const priceValue = typeof price === 'number' ? price : (price ? Number(price) : 0);
            
            const currencyId = priceItem?.currencyId;
            let currencyValue: number | undefined;
            if (typeof currencyId === 'number') {
              currencyValue = currencyId;
            } else if (typeof currencyId === 'object' && currencyId !== null && 'value' in currencyId) {
              currencyValue = typeof currencyId.value === 'number' ? currencyId.value : Number(currencyId.value);
            }
            
            // Проверяем, что и цена > 0, и валюта > 0
            return priceValue > 0 && currencyValue && currencyValue > 0;
          });
          
          // Проверяем старые поля для обратной совместимости
          const hasOldValidPrice = (block.priceLight && block.priceLight > 0 && block.currencyLightId) || 
                                   (block.priceMidsize && block.priceMidsize > 0 && block.currencyMidsizeId);
          
          if (!hasAnyValidPrice && !hasOldValidPrice) {
            missingFields.push(`blocks[${index}]: необходимо заполнить хотя бы одну цену (больше 0) и валюту`);
          }
          
          // Проверки для старых полей: если цена заполнена, валюта обязательна
          if (block.priceLight && block.priceLight > 0 && !block.currencyLightId) {
            missingFields.push(`blocks[${index}].currencyLightId (когда указана цена Light)`);
          }
          if (block.priceMidsize && block.priceMidsize > 0 && !block.currencyMidsizeId) {
            missingFields.push(`blocks[${index}].currencyMidsizeId (когда указана цена Midsize)`);
          }
          
          // Проверяем новую структуру: если цена > 0, валюта обязательна
          if (block.prices && Array.isArray(block.prices)) {
            block.prices.forEach((priceItem: IEventBlockPrice, priceIndex: number) => {
              const price = priceItem?.price;
              const priceValue = typeof price === 'number' ? price : (price ? Number(price) : 0);
              
              if (priceValue > 0) {
                const currencyId = priceItem?.currencyId;
                let currencyValue: number | undefined;
                if (typeof currencyId === 'number') {
                  currencyValue = currencyId;
                } else if (typeof currencyId === 'object' && currencyId !== null && 'value' in currencyId) {
                  currencyValue = typeof currencyId.value === 'number' ? currencyId.value : Number(currencyId.value);
                }
                
                if (!currencyValue || currencyValue <= 0) {
                  missingFields.push(`blocks[${index}].prices[${priceIndex}].currencyId (когда указана цена)`);
                }
              }
            });
          }
        });
      }
    }
    
    if (missingFields.length > 0) {
      console.error('=== Missing required fields ===');
      missingFields.forEach(field => console.error('  -', field));
      
      // Устанавливаем ошибки на конкретные поля
      const fieldErrors: any[] = [];
      
      if (!values.eventName) {
        fieldErrors.push({
          name: ['eventName'],
          errors: [intl.formatMessage(CommonFormMessages.ruleRequired)]
        });
      }
      if (!values.color) {
        fieldErrors.push({
          name: ['color'],
          errors: [intl.formatMessage(CommonFormMessages.ruleRequired)]
        });
      }
      if (!values.dateRange || !values.dateRange[0] || !values.dateRange[1]) {
        fieldErrors.push({
          name: ['dateRange'],
          errors: [intl.formatMessage(CommonFormMessages.ruleRequired)]
        });
      }
      
      if (isSeason) {
        if (!values.seasonType) {
          fieldErrors.push({
            name: ['seasonType'],
            errors: [intl.formatMessage(CommonFormMessages.ruleRequired)]
          });
        }
        // Для сезонов проверяем prices
        // Проверяем только наличие валюты, цена не обязательна (будет 0 если не указана)
        if (values.prices && Array.isArray(values.prices)) {
          // Проверяем, что есть хотя бы одна валюта
          const hasAnyCurrency = values.prices.some((p: IEventBlockPrice) => {
            const currencyId = p?.currencyId;
            if (typeof currencyId === 'number') {
              return currencyId > 0;
            } else if (typeof currencyId === 'object' && currencyId !== null && 'value' in currencyId) {
              const currencyValue = typeof currencyId.value === 'number' ? currencyId.value : Number(currencyId.value);
              return currencyValue > 0;
            }
            return false;
          });
          
          if (!hasAnyCurrency && values.prices.length > 0) {
            // Устанавливаем ошибку на первое поле валюты
            fieldErrors.push({
              name: ['prices', 0, 'currencyId'],
              errors: [intl.formatMessage(CommonFormMessages.ruleRequired)]
            });
          }
        }
      } else {
        // Для событий проверяем blocks
        if (!values.blocks || values.blocks.length === 0) {
          // Если нет блоков, это уже обработается валидацией формы
        } else {
          values.blocks.forEach((block, blockIndex) => {
            const blockPrices = block.prices || [];
            // Проверяем наличие хотя бы одной валюты (цена не обязательна, будет 0)
            const hasAnyCurrency = blockPrices.some((priceItem: IEventBlockPrice) => {
              const currencyId = priceItem?.currencyId;
              let currencyIdNum: number | undefined;
              if (typeof currencyId === 'number') {
                currencyIdNum = currencyId;
              } else if (typeof currencyId === 'object' && currencyId !== null && 'value' in currencyId) {
                currencyIdNum = typeof currencyId.value === 'number' ? currencyId.value : Number(currencyId.value);
              }
              return currencyIdNum && currencyIdNum > 0;
            });
            
            // Если нет валюты в блоке, требуем хотя бы одну
            if (!hasAnyCurrency && blockPrices.length > 0) {
              // Находим первое поле без валюты
              const firstEmptyIndex = blockPrices.findIndex((p: IEventBlockPrice) => {
                const currencyId = p?.currencyId;
                if (typeof currencyId === 'number') {
                  return !currencyId || currencyId === 0;
                } else if (typeof currencyId === 'object' && currencyId !== null && 'value' in currencyId) {
                  const currencyValue = typeof currencyId.value === 'number' ? currencyId.value : Number(currencyId.value);
                  return !currencyValue || currencyValue === 0;
                }
                return true;
              });
              const targetIndex = firstEmptyIndex >= 0 ? firstEmptyIndex : 0;
              
              fieldErrors.push({
                name: ['blocks', blockIndex, 'prices', targetIndex, 'currencyId'],
                errors: [intl.formatMessage(CommonFormMessages.ruleRequired)]
              });
            }
          });
        }
      }
      
      if (fieldErrors.length > 0) {
        form.setFields(fieldErrors);
        return;
      }
    }
    
    if (isSeason) {
      // Для сезонов создаем одно событие с season_type и блоками
      // Создаем блоки без аэропортов (airportIds: null) для всех аэропортов
      const blocks: Array<{
        airportIds: null;
        prices: Array<{
          planeTypeId: number;
          currencyId: number;
          price: number;
        }>;
      }> = [];
      
      // Создаем массив prices из новой структуры
      const prices: Array<{
        planeTypeId: number;
        currencyId: number;
        price: number;
      }> = [];
      
            // Используем новую структуру prices, если она есть
            if (values.prices && Array.isArray(values.prices)) {
              values.prices.forEach((priceItem: IEventBlockPrice, priceIndex: number) => {
                // Преобразуем currencyId из объекта в число, если нужно
                let currencyId: number | undefined;
                if (priceItem.currencyId) {
                  if (typeof priceItem.currencyId === 'number') {
                    currencyId = priceItem.currencyId;
                  } else if (typeof priceItem.currencyId === 'object' && 'value' in priceItem.currencyId) {
                    currencyId = priceItem.currencyId.value as number;
                  }
                }
                
                // Используем planeCategoryId или planeTypeId (для обратной совместимости)
                // Если их нет, используем индекс элемента в массиве для определения категории из planeCategories
                let categoryId = priceItem.planeCategoryId || priceItem.planeTypeId;
                if (!categoryId && planeCategories.length > priceIndex) {
                  categoryId = Number(planeCategories[priceIndex].value);
                }
                
                // Если есть валюта и категория, добавляем цену (если прайс пустой, отправляем 0)
                if (currencyId && categoryId) {
                  const finalPrice = priceItem.price && priceItem.price > 0 ? priceItem.price : 0;
                  prices.push({
                    planeTypeId: categoryId, // Бекенд ожидает planeTypeId (но это на самом деле категория)
                    currencyId: currencyId,
                    price: finalPrice,
                  });
                }
              });
      } else {
        // Обратная совместимость со старыми полями
      if (values.priceLight && currencyLightId) {
        prices.push({
          planeTypeId: 1, // Light
          currencyId: currencyLightId,
          price: values.priceLight,
        });
      }
      if (values.priceMidsize && currencyMidsizeId) {
        prices.push({
          planeTypeId: 2, // Midsize
          currencyId: currencyMidsizeId,
          price: values.priceMidsize,
        });
        }
      }
      
      // Добавляем блок только если есть хотя бы одна цена
      if (prices.length > 0) {
        blocks.push({
          airportIds: null,
          prices: prices,
        });
      }
      
      // Проверяем, что blocks не пустой
      if (blocks.length === 0) {
        message.error(intl.formatMessage(CommonFormMessages.ruleRequired));
        return;
      }
      
      if (editEvent) {
        // Редактирование события
        dispatch(updateEventCalendar({
          eventCalendar: {
            ...editEvent,
            eventName: values.eventName,
            dateFrom: values.dateRange[0].format('YYYY-MM-DD HH:mm:ss'),
            dateTo: values.dateRange[1].format('YYYY-MM-DD HH:mm:ss'),
            seasonType: values.seasonType || editEvent.seasonType || 'high',
            color: values.color,
            source: isSystemAdmin && editEvent.source === 'system' ? 'system' : 'operator_admin',
            blocks: blocks,
          },
        }));
      } else {
        // Создание нового события
        // Генерируем уникальный timestamp для отслеживания последовательных созданий
        const requestTimestamp = Date.now();
        createRequestTimestampRef.current = requestTimestamp;
        dispatch(createEventCalendar({
          eventCalendar: {
            eventName: values.eventName,
            dateFrom: values.dateRange[0].format('YYYY-MM-DD HH:mm:ss'),
            dateTo: values.dateRange[1].format('YYYY-MM-DD HH:mm:ss'),
            source: isSystemAdmin ? 'system' : 'operator_admin',
            seasonType: values.seasonType || 'high',
            color: values.color,
            blocks: blocks,
          },
          requestTimestamp,
        }));
      }
    } else {
      // Для событий создаем одно событие с блоками
      const blocks = values.blocks?.map((block, blockIndex) => {
        // Создаем массив prices из новой структуры
        const prices: Array<{
          planeTypeId: number;
          currencyId: number;
          price: number;
        }> = [];
        
        // Используем новую структуру prices, если она есть
        if (block.prices && Array.isArray(block.prices)) {
          block.prices.forEach((priceItem: IEventBlockPrice, priceIndex: number) => {
            // Преобразуем currencyId из объекта в число, если нужно
            let currencyId: number | undefined;
            if (priceItem.currencyId) {
              if (typeof priceItem.currencyId === 'number') {
                currencyId = priceItem.currencyId;
              } else if (typeof priceItem.currencyId === 'object' && 'value' in priceItem.currencyId) {
                currencyId = priceItem.currencyId.value as number;
              }
            }
            
            // Используем planeCategoryId или planeTypeId (для обратной совместимости)
            // Если их нет, используем индекс элемента в массиве для определения категории из planeCategories
            let categoryId = priceItem.planeCategoryId || priceItem.planeTypeId;
            if (!categoryId && planeCategories.length > priceIndex) {
              categoryId = Number(planeCategories[priceIndex].value);
            }
            
            // Если есть валюта и категория, добавляем цену (если прайс пустой, отправляем 0)
            if (currencyId && categoryId) {
              // Если цена не указана или равна 0, используем 0
              const priceValue = priceItem.price ? Number(priceItem.price) : 0;
              prices.push({
                planeTypeId: categoryId, // Бекенд ожидает planeTypeId (но это на самом деле категория)
                currencyId: currencyId,
                price: priceValue,
              });
              console.log(`  ✓ Added price to array: price=${priceValue}`);
            } else if (currencyId && !categoryId) {
              // Если есть валюта, но нет категории - используем индекс для определения категории
              if (planeCategories.length > priceIndex) {
                const categoryIdFromIndex = Number(planeCategories[priceIndex].value);
                const priceValue = priceItem.price ? Number(priceItem.price) : 0;
                prices.push({
                  planeTypeId: categoryIdFromIndex,
                  currencyId: currencyId,
                  price: priceValue,
                });
                console.log(`  ✓ Added price to array (using index): price=${priceValue}, categoryId=${categoryIdFromIndex}`);
              } else {
                console.log(`  ✗ Skipped price item ${priceIndex}: no category found for index ${priceIndex}`);
              }
            } else {
              console.log(`  ✗ Skipped price item ${priceIndex}: currencyId=${currencyId}, categoryId=${categoryId}`);
            }
          });
        } else {
          // Обратная совместимость со старыми полями
        if (block.priceLight && block.currencyLightId) {
          prices.push({
            planeTypeId: 1, // Light
            currencyId: block.currencyLightId,
            price: block.priceLight,
          });
        }
        if (block.priceMidsize && block.currencyMidsizeId) {
          prices.push({
            planeTypeId: 2, // Midsize
            currencyId: block.currencyMidsizeId,
            price: block.priceMidsize,
          });
          }
        }
        
        // airportIds - это просто массив чисел
        const airportIds = block.airportIds || [];
        
        return {
          airportIds: airportIds,
          prices: prices,
        };
      }).filter(block => {
        const hasPrices = block.prices.length > 0;
        return hasPrices;
      }) || [];
      
      // Проверяем, что blocks не пустой
      if (blocks.length === 0) {
        console.error('ERROR: blocks.length === 0, showing error message');
        message.error('Необходимо заполнить хотя бы одну цену и валюту');
        return;
      }
      
      // Проверяем dateRange перед отправкой
      if (!values.dateRange || !values.dateRange[0] || !values.dateRange[1]) {
        console.error('dateRange validation failed:', {
          dateRange: values.dateRange,
          dateRange0: values.dateRange?.[0],
          dateRange1: values.dateRange?.[1],
        });
        message.error('Необходимо указать даты события');
        return;
      }
      
      if (editEvent) {
        // Редактирование события
        dispatch(updateEventCalendar({
          eventCalendar: {
            ...editEvent,
            eventName: values.eventName,
            dateFrom: values.dateRange[0].format('YYYY-MM-DD HH:mm:ss'),
            dateTo: values.dateRange[1].format('YYYY-MM-DD HH:mm:ss'),
            color: values.color,
            source: isSystemAdmin && editEvent.source === 'system' ? 'system' : 'operator_admin',
            blocks: blocks,
          },
        }));
      } else {
        // Создание нового события
        // Генерируем уникальный timestamp для отслеживания последовательных созданий
        const requestTimestamp = Date.now();
        createRequestTimestampRef.current = requestTimestamp;
        dispatch(createEventCalendar({
          eventCalendar: {
            eventName: values.eventName,
            dateFrom: values.dateRange[0].format('YYYY-MM-DD HH:mm:ss'),
            dateTo: values.dateRange[1].format('YYYY-MM-DD HH:mm:ss'),
            source: isSystemAdmin ? 'system' : 'operator_admin',
            color: values.color,
            blocks: blocks,
          },
          requestTimestamp,
        }));
      }
    }
  }

  const onFinishFailed = (errorInfo: any) => {
    console.error('=== EventCalendarCreateModal: onFinishFailed ===');
    console.error('Error info:', JSON.stringify(errorInfo, null, 2));
    console.error('Form values:', JSON.stringify(form.getFieldsValue(), null, 2));
    
    if (errorInfo.errorFields && errorInfo.errorFields.length > 0) {
      console.error('=== Validation errors ===');
      errorInfo.errorFields.forEach((errorField: any, index: number) => {
        console.error(`Error ${index + 1}:`, {
          name: errorField.name,
          errors: errorField.errors,
          value: errorField.value
        });
        console.error(`  Field path: ${JSON.stringify(errorField.name)}`);
        console.error(`  Error messages: ${errorField.errors.join(', ')}`);
        console.error(`  Field value:`, errorField.value);
      });
    } else {
      console.error('No errorFields in errorInfo');
    }
    
    // Проверяем все поля формы на наличие ошибок
    const fieldsError = form.getFieldsError();
    if (fieldsError.length > 0) {
      console.error('=== Form fields with errors ===');
      fieldsError.forEach((fieldError: any) => {
        console.error(`Field: ${JSON.stringify(fieldError.name)}, Errors: ${fieldError.errors.join(', ')}`);
      });
    }
    
    message.error(intl.formatMessage(CommonFormMessages.incorrect));
  }

  const fetchAllAirports = (search: string) => {
    return fetchAirports(search);
  };

  const initialValues: Partial<IEventCalendarCreateFormData> = duplicateFrom ? {
    eventName: duplicateFrom.eventName,
    color: '#1890FF',
    dateRange: [dayjs(duplicateFrom.dateFrom), dayjs(duplicateFrom.dateTo)],
    ...(isSeason ? {
      prices: planeCategories.map(planeCategory => {
        const defaultCurrency = userCurrency && userCurrency.id ? getInitialCurrencyForSelect(userCurrency) : undefined;
        return {
          planeCategoryId: Number(planeCategory.value),
          planeTypeId: Number(planeCategory.value), // Для совместимости
          price: undefined,
          currencyId: defaultCurrency?.value ? Number(defaultCurrency.value) : undefined, // Преобразуем в число
        };
      }),
      seasonType: duplicateFrom.seasonType || 'high',
    } : {
      blocks: [{
        airportIds: [],
        prices: planeCategories.map(planeCategory => {
          const defaultCurrency = userCurrency && userCurrency.id ? getInitialCurrencyForSelect(userCurrency) : undefined;
          return {
            planeCategoryId: Number(planeCategory.value),
            planeTypeId: Number(planeCategory.value), // Для совместимости
            price: undefined,
            currencyId: defaultCurrency?.value ? Number(defaultCurrency.value) : undefined, // Преобразуем в число
          };
        }),
      }],
    }),
  } : {
    eventName: undefined,
    color: '#1890FF',
    dateRange: [
      dayjs().startOf('day').hour(0).minute(0).second(0), // 00:00 текущей даты
      dayjs().startOf('day').hour(23).minute(59).second(59) // 23:59 текущей даты
    ],
      ...(isSeason ? {
        prices: planeCategories.map(planeCategory => {
          const defaultCurrency = userCurrency && userCurrency.id ? getInitialCurrencyForSelect(userCurrency) : undefined;
          return {
            planeCategoryId: Number(planeCategory.value),
            planeTypeId: Number(planeCategory.value), // Для совместимости
            price: undefined,
            currencyId: defaultCurrency?.value ? Number(defaultCurrency.value) : undefined, // Преобразуем в число
          };
        }),
        seasonType: 'high',
      } : {
        blocks: [{
          airportIds: [],
          prices: planeCategories.map(planeCategory => {
            const defaultCurrency = userCurrency && userCurrency.id ? getInitialCurrencyForSelect(userCurrency) : undefined;
            return {
              planeCategoryId: Number(planeCategory.value),
              planeTypeId: Number(planeCategory.value), // Для совместимости
              price: undefined,
              currencyId: defaultCurrency?.value ? Number(defaultCurrency.value) : undefined, // Преобразуем в число
            };
          }),
        }],
      }),
  }

  // Обработчик для отслеживания открытия/закрытия дропдаунов
  const handleDropdownVisibleChange = (open: boolean) => {
    setOpenDropdownsCount(prev => open ? prev + 1 : Math.max(0, prev - 1));
  };

  return (
    <StyledEventCalendarModal
      title={editEvent 
        ? intl.formatMessage(EventCalendarCreateModalMessages.titleEdit)
        : intl.formatMessage(EventCalendarCreateModalMessages.title)}
      open={isModalVisible}
      onCancel={() => {
        form.resetFields();
        setIsModalVisible(false);
      }}
      centered
      footer={null}
      width={isSeason ? 500 : 800}
      isDropdownOpen={openDropdownsCount > 0}
    >
      <Form
        form={form}
        onFinish={(values) => onFinishTrimmed(values, onFinish)}
        onFinishFailed={onFinishFailed}
        layout={'vertical'}
        initialValues={initialValues}
      >
        <ColorColWrapper>
          <Row gutter={16} align="stretch">
            <Col flex={1}>
              <CustomFieldInput
                label={intl.formatMessage(EventCalendarCreateModalMessages.eventName)}
                name={'eventName'}
                rules={[{required: true, message: intl.formatMessage(CommonFormMessages.ruleRequired)}]}
              >
                <Input placeholder={intl.formatMessage(EventCalendarCreateModalMessages.eventName)}/>
              </CustomFieldInput>
            </Col>

            <Col flex="none">
              <ColorFieldWrapper>
                <CustomFieldInput
                  label={intl.formatMessage(EventCalendarCreateModalMessages.color)}
                  name={'color'}
                  rules={[{required: true, message: intl.formatMessage(CommonFormMessages.ruleRequired)}]}
                >
                  <ColorPicker />
                </CustomFieldInput>
              </ColorFieldWrapper>
            </Col>
          </Row>
        </ColorColWrapper>

        <Col flex={1}>
          <CustomFieldInput
            label={`${intl.formatMessage(EventCalendarCreateModalMessages.eventDates)} (UTC)`}
            name={'dateRange'}
            rules={[{required: true, message: intl.formatMessage(CommonFormMessages.ruleRequired)}]}
          >
            <DateAndTimeRangePicker
              format="DD.MM.YYYY HH:mm"
              placeholder={[
                intl.formatMessage(EventCalendarCreateModalMessages.dateFrom),
                intl.formatMessage(EventCalendarCreateModalMessages.dateTo)
              ]}
              inputReadOnly={true}
              placement={"bottomLeft"}
              getPopupContainer={trigger => trigger.parentNode as HTMLElement}
            />
          </CustomFieldInput>
        </Col>

        {!isSeason && <Form.List name="blocks">
          {(fields, {add, remove}) => (
            <>
              {fields.map((field, index) => (
                <BlockWrapper key={field.key}>
                  <BlockTitle>
                    <span>
                      {intl.formatMessage(EventCalendarCreateModalMessages.block)} {index + 1}
                    </span>
                    {fields.length > 1 && (
                      <RemoveBlockButton onClick={() => remove(field.name)} />
                    )}
                  </BlockTitle>
                  
                  <Col flex={1} style={{marginBottom: 16}}>
                    <CustomFieldInput
                      label={intl.formatMessage(EventCalendarCreateModalMessages.airport)}
                      name={[field.name, 'airportIds']}
                      >
                        <DebounceSelect
                          mode="multiple"
                          fetchOptions={fetchAllAirports}
                          placeholder={intl.formatMessage(EventCalendarCreateModalMessages.airport)}
                          showSearch={true}
                          allowClear={true}
                          onDropdownVisibleChange={handleDropdownVisibleChange}
                        />
                    </CustomFieldInput>
                  </Col>
                  
                  {/* Динамические поля для каждой категории самолета */}
                  {planeCategories.map((planeCategory, categoryIndex) => (
                    <Row gutter={16} key={planeCategory.value} style={{marginTop: categoryIndex === 0 ? 0 : 16}}>
                    <Col flex={1}>
                      <CustomFieldInput
                          label={`${intl.formatMessage(CommonFormMessages.priceLabel)} (${planeCategory.label})`}
                          name={[field.name, 'prices', categoryIndex, 'price']}
                        rules={[
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              const currencyValue = getFieldValue(['blocks', field.name, 'prices', categoryIndex, 'currencyId']);
                              
                              // Валидация убрана - цена не обязательна
                              // Если есть валюта, но нет цены, на бек будет отправлено 0
                              return Promise.resolve();
                            },
                          }),
                          {
                            min: 0,
                            type: "number",
                            message: intl.formatMessage(CommonFormMessages.ruleMinimumZero)
                          },
                          {
                            max: 1000000000,
                            type: "number",
                            message: intl.formatMessage(CommonFormMessages.ruleHugeNumber)
                          }
                        ]}
                      >
                        <CustomInputNumber
                            placeholder={`${intl.formatMessage(CommonFormMessages.priceLabel)} (${planeCategory.label})`}
                          style={{width: '100%'}}
                          controls={false}
                          min={0}
                          onlyDigits
                          parser={(value) => {
                            if (!value) return '' as any;
                            // Remove spaces and non-digits, then limit to 8 digits
                            const withoutSpaces = value.replace(/\s/g, '');
                            const digitsOnly = withoutSpaces.replace(/\D/g, '');
                            if (!digitsOnly) return '' as any;
                            return digitsOnly.slice(0, 8) as any;
                          }}
                          onKeyDown={(e) => {
                            const target = e.target as HTMLInputElement;
                            const currentValue = target.value?.replace(/\s/g, '') || '';
                            // Prevent input if already 8 digits and key is not a control key
                            if (currentValue.length >= 8 && 
                                e.key.length === 1 && 
                                /[0-9]/.test(e.key) &&
                                !(e.ctrlKey || e.metaKey || e.altKey)) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </CustomFieldInput>
                    </Col>
                    <Col flex={1} style={{minWidth: '47%'}}>
                      <CustomFieldInput
                        label={intl.formatMessage(CommonFormMessages.currencyLabel)}
                        name={[field.name, 'prices', categoryIndex, 'currencyId']}
                        rules={[
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              // Получаем текущий блок и все цены
                              const block = getFieldValue(['blocks', field.name]);
                              const blockPrices = block?.prices || [];
                              
                              // Получаем текущую цену
                              const currentPrice = getFieldValue(['blocks', field.name, 'prices', categoryIndex, 'price']);
                              const priceValue = typeof currentPrice === 'number' ? currentPrice : (currentPrice ? Number(currentPrice) : 0);
                              
                              // Проверяем, есть ли хотя бы одна заполненная пара (цена > 0 И валюта > 0) в блоке
                              let hasAnyValidPrice = false;
                              blockPrices.forEach((priceItem: IEventBlockPrice, idx: number) => {
                                if (hasAnyValidPrice) return; // Уже нашли валидную пару
                                
                                const p = priceItem?.price;
                                const priceNum = typeof p === 'number' ? p : (p ? Number(p) : 0);
                                
                                const c = priceItem?.currencyId;
                                let currencyIdNum: number | undefined;
                                if (typeof c === 'number') {
                                  currencyIdNum = c;
                                } else if (typeof c === 'object' && c !== null && 'value' in c) {
                                  currencyIdNum = typeof c.value === 'number' ? c.value : Number(c.value);
                                }
                                
                                // Если это текущий элемент, используем значения из формы
                                if (idx === categoryIndex) {
                                  const currentPriceValue = priceValue;
                                  const currentCurrencyValue = typeof value === 'number' ? value : (value && typeof value === 'object' && 'value' in value ? (typeof value.value === 'number' ? value.value : Number(value.value)) : undefined);
                                  if (currentPriceValue > 0 && currentCurrencyValue && currentCurrencyValue > 0) {
                                    hasAnyValidPrice = true;
                                  }
                                } else {
                                  // Для других элементов используем значения из priceItem
                                  if (priceNum > 0 && currencyIdNum && currencyIdNum > 0) {
                                    hasAnyValidPrice = true;
                                  }
                                }
                              });
                              
                              // Если цена заполнена (> 0), валюта обязательна
                              if (priceValue > 0) {
                                if (!value || value === null || value === undefined) {
                                  return Promise.reject(new Error(intl.formatMessage(CommonFormMessages.ruleRequired)));
                                }
                              }
                              
                              // Если нет ни одной валидной пары в блоке, проверяем, нужно ли требовать заполнение
                              if (!hasAnyValidPrice) {
                                // Проверяем, есть ли еще категории после текущей
                                const remainingCategories = blockPrices.slice(categoryIndex + 1);
                                const hasRemainingCategories = remainingCategories.length > 0;
                                
                                // Если это последняя категория или нет других категорий, требуем заполнения хотя бы одной пары
                                if (!hasRemainingCategories || categoryIndex === blockPrices.length - 1) {
                                  // Если валюта заполнена, но цена не заполнена - это нормально (цена будет 0)
                                  // Но если ничего не заполнено - это ошибка
                                  const currentCurrencyValue = typeof value === 'number' ? value : (value && typeof value === 'object' && 'value' in value ? (typeof value.value === 'number' ? value.value : Number(value.value)) : undefined);
                                  if (!currentCurrencyValue && priceValue === 0) {
                                    return Promise.reject(new Error('Необходимо заполнить хотя бы одну цену (больше 0) и валюту'));
                                  }
                                }
                              }
                              
                              return Promise.resolve();
                            },
                          }),
                        ]}
                      >
                        <Form.Item
                          noStyle
                          shouldUpdate={(prevValues, currentValues) => {
                            const prevCurrency = prevValues.blocks?.[field.name]?.prices?.[categoryIndex]?.currencyId;
                            const currentCurrency = currentValues.blocks?.[field.name]?.prices?.[categoryIndex]?.currencyId;
                            return prevCurrency !== currentCurrency;
                          }}
                        >
                          {({ getFieldValue }) => {
                            const currencyValue = getFieldValue(['blocks', field.name, 'prices', categoryIndex, 'currencyId']);
                            let defaultOptions: DebounceSelectOptionProps[] = [];
                            
                            if (currencyValue) {
                              if (typeof currencyValue === 'number') {
                                const currencies = getCurrenciesFromStoreByIds([currencyValue]);
                                defaultOptions = currencies.length > 0 ? currencies : [];
                              } else if (typeof currencyValue === 'object' && 'value' in currencyValue) {
                                defaultOptions = [currencyValue as DebounceSelectOptionProps];
                              }
                            } else {
                              // Если currencyValue нет, используем дефолтную валюту из user/company (как в UserSettingsDrawer)
                              if (userCurrency && userCurrency.id) {
                                defaultOptions = [getInitialCurrencyForSelect(userCurrency)];
                              }
                            }
                            
                            // Преобразуем число обратно в объект для отображения в селекте
                            // selectValue должен быть объектом DebounceSelectOptionProps или undefined, но не числом
                            let selectValue: DebounceSelectOptionProps | undefined;
                            
                            if (currencyValue) {
                              if (typeof currencyValue === 'number') {
                                // Если это число, пытаемся найти валюту в defaultOptions или в store
                                if (defaultOptions.length > 0) {
                                  selectValue = defaultOptions[0];
                                } else {
                                  // Если не нашли в defaultOptions, пытаемся найти в store
                                  const currenciesFromStore = getCurrenciesFromStoreByIds([currencyValue]);
                                  selectValue = currenciesFromStore.length > 0 ? currenciesFromStore[0] : undefined;
                                }
                              } else if (typeof currencyValue === 'object' && 'value' in currencyValue) {
                                // Если это уже объект, используем его
                                selectValue = currencyValue as DebounceSelectOptionProps;
                              }
                            } else {
                              // Если currencyValue нет, используем дефолтную валюту из defaultOptions
                              selectValue = defaultOptions.length > 0 ? defaultOptions[0] : undefined;
                              
                              // Если есть дефолтное значение, но его нет в форме, устанавливаем его автоматически
                              if (selectValue && !editEvent) {
                                setTimeout(() => {
                                  if (!selectValue) return;
                                  const currencyValue = getFieldValue(['blocks', field.name, 'prices', categoryIndex, 'currencyId']);
                                  if (!currencyValue) {
                                    const currencyId = typeof selectValue.value === 'number' 
                                      ? selectValue.value 
                                      : Number(selectValue.value);
                                    const currentValues = form.getFieldsValue();
                                    const currentBlocks = [...(currentValues.blocks || [])];
                                    if (!currentBlocks[field.name]) {
                                      currentBlocks[field.name] = { prices: [] };
                                    }
                                    if (!currentBlocks[field.name].prices) {
                                      currentBlocks[field.name].prices = [];
                                    }
                                    const updatedPrices = [...currentBlocks[field.name].prices];
                                    updatedPrices[categoryIndex] = {
                                      ...updatedPrices[categoryIndex],
                                      currencyId: currencyId
                                    };
                                    currentBlocks[field.name] = {
                                      ...currentBlocks[field.name],
                                      prices: updatedPrices
                                    };
                                    form.setFieldsValue({
                                      blocks: currentBlocks
                                    });
                                  }
                                }, 0);
                              }
                            }
                            
                            return (
                              <DebounceSelect
                                fetchOptions={fetchCurrencies}
                                placeholder={intl.formatMessage(CommonFormMessages.currencyPlaceholder)}
                                defaultOptions={defaultOptions}
                                value={selectValue}
                                onDropdownVisibleChange={handleDropdownVisibleChange}
                                onChange={(value) => {
                                  // Преобразуем объект в число при изменении
                                  const currencyId = value && typeof value === 'object' && 'value' in value 
                                    ? value.value 
                                    : value;
                                  // Используем form.setFieldsValue для правильного обновления значения
                                  const currentValues = form.getFieldsValue();
                                  const currentBlocks = [...(currentValues.blocks || [])];
                                  if (!currentBlocks[field.name]) {
                                    currentBlocks[field.name] = { prices: [] };
                                  }
                                  if (!currentBlocks[field.name].prices) {
                                    currentBlocks[field.name].prices = [];
                                  }
                                  const updatedPrices = [...currentBlocks[field.name].prices];
                                  updatedPrices[categoryIndex] = {
                                    ...updatedPrices[categoryIndex],
                                    currencyId: currencyId
                                  };
                                  currentBlocks[field.name] = {
                                    ...currentBlocks[field.name],
                                    prices: updatedPrices
                                  };
                                  form.setFieldsValue({
                                    blocks: currentBlocks
                                  });
                                  // Триггерим валидацию после обновления значения
                                  setTimeout(() => {
                                    form.validateFields([['blocks', field.name, 'prices', categoryIndex, 'currencyId']]);
                                  }, 0);
                                }}
                              />
                            );
                          }}
                        </Form.Item>
                      </CustomFieldInput>
                    </Col>
                  </Row>
                  ))}
                </BlockWrapper>
              ))}
              
              <AddBlockButton
                type="link"
                icon={<PlusOutlined />}
                onClick={() => {
                  const defaultCurrency = userCurrency && userCurrency.id ? getInitialCurrencyForSelect(userCurrency) : undefined;
                  // Инициализируем массив prices для каждой категории самолета
                  const prices = planeCategories.map(planeCategory => ({
                    planeCategoryId: Number(planeCategory.value),
                    planeTypeId: Number(planeCategory.value), // Для совместимости с бекендом
                    price: undefined,
                    currencyId: defaultCurrency,
                  }));
                  add({
                    airportIds: [],
                    prices: prices,
                  });
                }}
                block
              >
                {intl.formatMessage(EventCalendarCreateModalMessages.addBlock)}
              </AddBlockButton>
            </>
          )}
        </Form.List>}

        {isSeason && (
          <>
            <Col flex={1}>
              <CustomFieldInput
                label={intl.formatMessage(EventCalendarCreateModalMessages.seasonType)}
                name={'seasonType'}
                rules={[{required: true, message: intl.formatMessage(CommonFormMessages.ruleRequired)}]}
              >
                <Radio.Group>
                  <Radio value="high">{intl.formatMessage(EventCalendarCreateModalMessages.highSeason)}</Radio>
                  <Radio value="low">{intl.formatMessage(EventCalendarCreateModalMessages.lowSeason)}</Radio>
                </Radio.Group>
              </CustomFieldInput>
            </Col>

            {/* Динамические поля для каждой категории самолета */}
            {planeCategories.map((planeCategory, categoryIndex) => (
              <Row gutter={16} key={planeCategory.value} style={{marginTop: categoryIndex === 0 ? 0 : 16}}>
              <Col flex={1}>
                <CustomFieldInput
                    label={`${intl.formatMessage(CommonFormMessages.priceLabel)} (${planeCategory.label})`}
                    name={['prices', categoryIndex, 'price']}
                  rules={[
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        // Валидация убрана - цена не обязательна
                        // Если есть валюта, но нет цены, на бек будет отправлено 0
                        return Promise.resolve();
                      },
                    }),
                    {
                      min: 0,
                      type: "number",
                      message: intl.formatMessage(CommonFormMessages.ruleMinimumZero)
                    },
                    {
                      max: 1000000000,
                      type: "number",
                      message: intl.formatMessage(CommonFormMessages.ruleHugeNumber)
                    }
                  ]}
                >
                  <CustomInputNumber
                      placeholder={`${intl.formatMessage(CommonFormMessages.priceLabel)} (${planeCategory.label})`}
                    style={{width: '100%'}}
                    controls={false}
                    min={0}
                    onlyDigits
                    parser={(value) => {
                      if (!value) return '' as any;
                      // Remove spaces and non-digits, then limit to 8 digits
                      const withoutSpaces = value.replace(/\s/g, '');
                      const digitsOnly = withoutSpaces.replace(/\D/g, '');
                      if (!digitsOnly) return '' as any;
                      return digitsOnly.slice(0, 8) as any;
                    }}
                    onKeyDown={(e) => {
                      const target = e.target as HTMLInputElement;
                      const currentValue = target.value?.replace(/\s/g, '') || '';
                      // Prevent input if already 8 digits and key is not a control key
                      if (currentValue.length >= 8 && 
                          e.key.length === 1 && 
                          /[0-9]/.test(e.key) &&
                          !(e.ctrlKey || e.metaKey || e.altKey)) {
                        e.preventDefault();
                      }
                    }}
                  />
                </CustomFieldInput>
              </Col>
              <Col flex={1} style={{minWidth: '47%'}}>
                <CustomFieldInput
                  label={intl.formatMessage(CommonFormMessages.currencyLabel)}
                  name={['prices', categoryIndex, 'currencyId']}
                  rules={[
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        // Валидация убрана - валюта не обязательна
                        // Если есть валюта, но нет цены, на бек будет отправлено price = 0
                        return Promise.resolve();
                      },
                    }),
                  ]}
                >
                  <Form.Item
                    noStyle
                    shouldUpdate={(prevValues, currentValues) => {
                      const prevCurrency = prevValues.prices?.[categoryIndex]?.currencyId;
                      const currentCurrency = currentValues.prices?.[categoryIndex]?.currencyId;
                      return prevCurrency !== currentCurrency;
                    }}
                  >
                    {({ getFieldValue }) => {
                      const currencyValue = getFieldValue(['prices', categoryIndex, 'currencyId']);
                      let defaultOptions: DebounceSelectOptionProps[] = [];
                      
                      if (currencyValue) {
                        if (typeof currencyValue === 'number') {
                          const currencies = getCurrenciesFromStoreByIds([currencyValue]);
                          defaultOptions = currencies.length > 0 ? currencies : [];
                        } else if (typeof currencyValue === 'object' && 'value' in currencyValue) {
                          defaultOptions = [currencyValue as DebounceSelectOptionProps];
                        }
                      } else {
                        // Если currencyValue нет, используем дефолтную валюту из user/company (как в UserSettingsDrawer)
                        if (userCurrency && userCurrency.id) {
                          defaultOptions = [getInitialCurrencyForSelect(userCurrency)];
                        }
                      }
                      
                      // Преобразуем число обратно в объект для отображения в селекте
                      // selectValue должен быть объектом DebounceSelectOptionProps или undefined, но не числом
                      let selectValue: DebounceSelectOptionProps | undefined;
                      
                      if (currencyValue) {
                        if (typeof currencyValue === 'number') {
                          // Если это число, пытаемся найти валюту в defaultOptions или в store
                          if (defaultOptions.length > 0) {
                            selectValue = defaultOptions[0];
                          } else {
                            // Если не нашли в defaultOptions, пытаемся найти в store
                            const currenciesFromStore = getCurrenciesFromStoreByIds([currencyValue]);
                            selectValue = currenciesFromStore.length > 0 ? currenciesFromStore[0] : undefined;
                          }
                        } else if (typeof currencyValue === 'object' && 'value' in currencyValue) {
                          // Если это уже объект, используем его
                          selectValue = currencyValue as DebounceSelectOptionProps;
                        }
                      } else {
                        // Если currencyValue нет, используем дефолтную валюту из defaultOptions
                        selectValue = defaultOptions.length > 0 ? defaultOptions[0] : undefined;
                        
                        // Если есть дефолтное значение, но его нет в форме, устанавливаем его автоматически
                        if (selectValue && !editEvent) {
                          setTimeout(() => {
                            if (!selectValue) return;
                            const currencyValue = getFieldValue(['prices', categoryIndex, 'currencyId']);
                            if (!currencyValue) {
                              const currencyId = typeof selectValue.value === 'number' 
                                ? selectValue.value 
                                : Number(selectValue.value);
                              const currentValues = form.getFieldsValue();
                              const currentPrices = [...(currentValues.prices || [])];
                              currentPrices[categoryIndex] = {
                                ...currentPrices[categoryIndex],
                                currencyId: currencyId
                              };
                              form.setFieldsValue({
                                prices: currentPrices
                              });
                            }
                          }, 0);
                        }
                      }
                      
                      return (
                        <DebounceSelect
                          fetchOptions={fetchCurrencies}
                          placeholder={intl.formatMessage(CommonFormMessages.currencyPlaceholder)}
                          defaultOptions={defaultOptions}
                          value={selectValue}
                          onDropdownVisibleChange={handleDropdownVisibleChange}
                          onChange={(value) => {
                            // Преобразуем объект в число при изменении
                            const currencyId = value && typeof value === 'object' && 'value' in value 
                              ? value.value 
                              : value;
                            // Используем form.setFieldsValue для правильного обновления значения
                            const currentValues = form.getFieldsValue();
                            const currentPrices = [...(currentValues.prices || [])];
                            currentPrices[categoryIndex] = {
                              ...currentPrices[categoryIndex],
                              currencyId: currencyId
                            };
                            form.setFieldsValue({
                              prices: currentPrices
                            });
                            // Триггерим валидацию после обновления значения
                            setTimeout(() => {
                              form.validateFields([['prices', categoryIndex, 'currencyId']]);
                            }, 0);
                          }}
                        />
                      );
                    }}
                  </Form.Item>
                </CustomFieldInput>
              </Col>
            </Row>
            ))}
          </>
        )}

        <Row gutter={16} style={{marginTop: 24}}>
          {editEvent && (
            <>
              {onDuplicate && (
                <Col flex={1}>
                  <CustomButton
                    block
                    type="default"
                    onClick={() => {
                      if (onDuplicate) {
                        onDuplicate();
                      }
                    }}
                  >
                    {intl.formatMessage(EventCalendarCreateModalMessages.duplicate)}
                  </CustomButton>
                </Col>
              )}
              {onDelete && (
                <Col flex={1}>
                  {/* Для системных событий (source === 'system') показываем "Скрыть" вместо "Удалить" для операторов */}
                  {editEvent.source === 'system' && !isSystemAdmin ? (
                    <CustomButton
                      block
                      type="default"
                      danger
                      loading={isHideLoading}
                      onClick={() => {
                        dispatch(hideEventCalendar({eventCalendarId: editEvent.eventCalendarId}));
                      }}
                    >
                      {intl.formatMessage(EventCalendarCreateModalMessages.hide)}
                    </CustomButton>
                  ) : (
                  <CustomButton
                    block
                    type="default"
                    danger
                    onClick={() => {
                      // Не закрываем модалку создания, просто вызываем onDelete для открытия модалки удаления
                      if (onDelete) {
                        onDelete();
                      }
                    }}
                  >
                    {intl.formatMessage(EventCalendarCreateModalMessages.delete)}
                  </CustomButton>
                  )}
                </Col>
              )}
            </>
          )}
          <Col flex={1}>
            <CustomButton
              block
              type="primary"
              htmlType="submit"
              loading={isLoading}
            >
              {editEvent 
                ? intl.formatMessage(CommonButtonMessages.save)
                : intl.formatMessage(CommonButtonMessages.create)}
            </CustomButton>
          </Col>
        </Row>
      </Form>
    </StyledEventCalendarModal>
  );
};
